module.exports = __webpack_public_path__ + "static/TreeCompany_LogoGreen-dc4b2c30e0551a6e864017728e6e0368.svg";